import React from 'react'
import ContactBox from '../components/ContactBox'
import './pages.css'

function experience() {
    return (

        <>
            <div className='c-box-body'>
            <ContactBox/></div>
            <div className='exp-body'>
            <h1>Experience</h1>
            <hr/>
            <p>Our knowledgeable and vast team of engineers and technicians across multiple continents means your systems are in the hands of the most skilled, capable and qualified professionals.
            </p>
            <p>Interested in our services? Call us today at <a href='tel:5862624219'>(586)262–4219</a>.</p>

            <hr/>

            <div className='table'>
                <table>
                    <thead >
                        <tr className = 'table-head'>
                            <th><b>Project</b></th>
                            <th><b>Location</b></th>
                            <th><b>Year</b></th>
                            
                        </tr>
                    </thead>
                    <tbody className='table-body'>
                    <tr className='tr1'>
                        <th>Corvette</th>
                        <th>General Motors (GM) in Tennessee</th>
                        <th>2004-2005</th>
                        </tr>
                        <tr>
                        <th>Dodge Caliber</th>
                        <th>Chrysler in Belvidere, Illinois</th>
                        <th>2005-2007</th>
                        </tr>
                        <tr className='tr1'>
                        <th>Dodge Heavy Duty Truck</th>
                        <th>Chrysler in Saltillo, Mexico</th>
                        <th>2007-2008</th>
                        </tr>
                        <tr>
                        <th>300 / Charger / Challenger</th>
                        <th>Chrysler in Brampton, Canada</th>
                        <th>2008-2009</th>
                        </tr>
                        <tr>
                        <th>Dodge 1500 Ram Truck</th>
                        <th>Chrysler in Warren, Michigan</th>
                        <th>2009</th>
                        </tr>
                        <tr>
                        <th>Production Support</th>
                        <th>Mercedes Benz in Alabama</th>
                        <th>2009</th>
                        </tr>
                        <tr>
                        <th>Ford Fiesta</th>
                        <th>Ford in Cuautitlan, Mexico City</th>
                        <th>2009-2010</th>
                        </tr>
                        <tr>
                        <th>Ford Explorer</th>
                        <th>Ford in Louisville, Kentucky</th>
                        <th>2010</th>
                        </tr>
                        <tr>
                        <th>Mini Van</th>
                        <th>Chrysler in Saint Louis, Missouri</th>
                        <th>2010</th>
                        </tr>
                        <tr>
                        <th>Ford Fiesta</th>
                        <th>Ford in Salvador, Brazil</th>
                        <th>2010-2012</th>
                        </tr>
                        <tr>
                        <th>Production Support</th>
                        <th>BMW in Spartanburg, South Carolina</th>
                        <th>2012</th>
                        </tr>
                        <tr>
                        <th>Ducato Van</th>
                        <th>Chrysler-Fiat in Saltillo, Mexico</th>
                        <th>2012-2014</th>
                        </tr>
                        <tr>
                        <th>Ford F-150 Truck</th>
                        <th>Ford Dearborn in Dearborn, Michigan</th>
                        <th>2012-2014</th>
                        </tr>
                        <tr>
                        <th>Mini Van</th>
                        <th>Chrysler in Windsor Ontario, Canada</th>
                        <th>2015</th>
                        </tr>
                        <tr>
                        <th>Fiat 500</th>
                        <th>Chrysler in Toluca, Mexico</th>
                        <th>2015</th>
                        </tr>
                        <tr>
                        <th>Lincoln / Fusion</th>
                        <th>Ford in Hermosillo, Mexico</th>
                        <th>2015</th>
                        </tr>
                        <tr>
                        <th>Spark</th>
                        <th>General Motors (GM) Ramos Arizpe, Mexico</th>
                        <th>2015</th>
                        </tr>
                        <tr>
                        <th>Ford Heavy Duty</th>
                        <th>Ford in Avon Lake, Ohio</th>
                        <th>2015</th>
                        </tr>
                        <tr>
                        <th>Ford Transit</th>
                        <th>Ford in Kansas City Missouri</th>
                        <th>2015</th>
                        </tr>
                        <tr>
                        <th>Small Car</th>
                        <th>General Motors (GM) in Kansas City Fairfax</th>
                        <th>2015</th>
                        </tr>
                        <tr>
                        <th>Cadillac</th>
                        <th>General Motors (GM) in Spring Hill, Tennessee</th>
                        <th>2015</th>
                        </tr>
                        <tr>
                        <th>Ford Escape</th>
                        <th>Ford in Salvidor, Brazil</th>
                        <th>2015</th>
                        </tr>
                        <tr>
                        <th>Ford Transit</th>
                        <th>Ford in Kansas City, Missouri</th>
                        <th>2016</th>
                        </tr>
                        <tr>
                        <th>Super Duty Ford</th>
                        <th>Ford in Louisville, Kentucky</th>
                        <th>2016</th>
                        </tr>
                        <tr>
                        <th>Fiat 500</th>
                        <th>FCA in Toluca, Mexico</th>
                        <th>2017</th>
                        </tr>
                        <tr>
                        <th>Chevy Equinox</th>
                        <th>GM in Ramos Arizpe, Mexico</th>
                        <th>2017</th>
                        </tr>
                        <tr>
                        <th>BMW 5 Series</th>
                        <th>BMW Group in Mexico City, Mexico</th>
                        <th>2018</th>
                        </tr>
                        <tr>
                        <th>Jeep Wrangler</th>
                        <th>Jeep in Toledo, Ohio (Jeep Plant)</th>
                        <th>2018</th>
                        </tr>
                        <tr>
                        <th>Jeep Gladiator</th>
                        <th>Jeep in Toledo, Ohio</th>
                        <th>2018</th>
                        </tr>
                        <tr>
                        <th>Heavy Duty Truck</th>
                        <th>FCA in Saltillo, Mexico</th>
                        <th>2018</th>
                        </tr>
                        <tr>
                        <th>Ram 1500</th>
                        <th>Warren, MI Truck Plant</th>
                        <th>2018</th>
                        </tr>
                        <tr>
                        <th>Ford Bronco</th>
                        <th>Ford in Hermosillo, Mexio</th>
                        <th>2018-2021</th>
                        </tr>
                        <tr>
                        <th>Tesla Batteries (Racking Systems)</th>
                        <th>Tesla Battery Plant in Nevada </th>
                        <th>2019</th>
                        </tr>
                        <tr>
                        <th>Model S</th>
                        <th>Tesla in California at Tesla Car Plant</th>
                        <th>2019</th>
                        </tr>
                        <tr>
                        <th>BMW X Series</th>
                        <th>BMW Group in Spartanburg, South Carolina</th>
                        <th>2019</th>
                        </tr>
                        <tr>
                        <th>Pro Master</th>
                        <th>FCA (Vaw Plant) in Saltillo, Mexico</th>
                        <th>2020</th>
                        </tr>
                        <tr>
                        <th>Truck Frame</th>
                        <th>Ford in Kentucky</th>
                        <th>2020</th>
                        </tr>
                        <tr>
                        <th>FCA Truck Parts</th>
                        <th>Flex & Gate in Warren, MI </th>
                        <th>2021</th>
                        </tr>
                        <tr>
                        <th>Pro Master</th>
                        <th>FCA (Vaw Plant) in Saltillo, Mexico</th>
                        <th>2021</th>
                        </tr>
                    </tbody>
                </table>
            </div>
        
        </div>
        </>
    )
}

export default experience
